import Alpine from "alpinejs";
import DOMPurify from "dompurify";

Alpine.magic("domPurify", () => (value) => {
    return DOMPurify.sanitize(value);
});
